module.exports = __webpack_public_path__ + "593a3d53/img/arrow-left-icon.785c715c.svg";